<template>
  <f7-page>
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        :back-link-url="backUrl">
      </f7-nav-left>
      <f7-nav-title>{{ this.$f7route.query.title }}</f7-nav-title>
      <f7-nav-right>
        <f7-link
          @click="editable = !editable"
          v-show="!editable && perms.projectUpdate">
          编辑
        </f7-link>
        <f7-link @click="add" v-show="editable">保存</f7-link>
      </f7-nav-right>
    </f7-navbar>
    <parent-header :parent="parent"></parent-header>
    <div class="has-content">
      <div v-show="!editable">
        <split-view
          :project="project"
          :isBuildingCompany="dictKey === 'majorContractType'"
          :assistMaterialsDisplay="assistMaterialsDisplay">
        </split-view>
      </div>
      <f7-list inline-labels id="splitForm" v-show="editable">
        <f7-list-input
          label="任务名称"
          type="text"
          :value="project.name"
          @input="project.name = $event.target.value"
          placeholder="请填写"
          required
          validate
          minlength=2
          maxlength=50
          error-message='长度2-50字符'>
          <div slot="media" class="input-required">*</div>
        </f7-list-input>
        <f7-list-input :input="false" v-show="parent.companyType === 'buildingCompany'">
          <div slot="media" class="input-required">*</div>
          <div slot="label">拆分方式</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-subpackageType"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-item
          title="专业承包类别"
          link=""
          @click="majorContractPopupOpened = true"
          v-show="project.subpackageType === 'professContract'">
          <div slot="media" class="input-required">*</div>
          <div slot="after">{{ majorContractDisplay }}</div>
          <f7-popup
            :opened="majorContractPopupOpened"
            @popup:closed="majorContractPopupOpened = false">
            <popup-radio
              title="专业承包类别"
              :data="majorContractTypeList"
              :result.sync="project.majorContractType">
            </popup-radio>
          </f7-popup>
        </f7-list-item>
        <f7-list-item
          link=""
          @click="scopePopupOpened = true"
          v-show="project.subpackageType !== 'professContract'">
          <div slot="media" class="input-required">*</div>
          <div slot="inner" class="item-title item-label">承(分)包范围</div>
          <div class="item-after popup-smart-select">{{ scopeDisplayVal }}</div>
          <f7-popup :opened="scopePopupOpened" @popup:closed="scopePopupOpened = false">
            <scope
              :dictKey="dictKey"
              :opened="scopePopupOpened"
              :result.sync="dutyScopeList">
            </scope>
          </f7-popup>
        </f7-list-item>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">开工日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-startTime"
            readonly
            required
            validate />
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">竣工日期</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="calendar-finishTime"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">工程规模</div>
          <div slot="input" style="display: flex;">
            <div>
              <input
                :value="project.projectSize"
                @input="project.projectSize = $event.target.value"
                type="number"
                placeholder="请填写"
                required
                validate
                min=0.00
                max=100000000.00
                step="0.01"
                data-error-message='支持两位小数'/>
            </div>
            <input
              type="text"
              placeholder="请选择"
              id="picker-sizeUnit"
              readonly
              required
              validate
              style="max-width: 4rem;"/>
          </div>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">所需人数</div>
          <input
            slot="input"
            :value="project.needUserNumber"
            @input="project.needUserNumber = $event.target.value"
            type="text"
            required
            validate
            data-error-message='必选项'
            placeholder="请填写"/>
          <div slot="inner-end" style="min-width: 3rem; text-align: right;">人</div>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">分包方式</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-subpackageMode"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">结算方式</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-settlement"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">分包单价</div>
          <div slot="input" style="display: flex;">
            <div>
              <input
                type="number"
                :value="project.prePrice"
                @input="project.prePrice = $event.target.value"
                placeholder="请填写"
                required
                validate
                min=0.00
                max=100000000.00
                step="0.01"
                data-error-message='支持两位小数'/>
            </div>
            <input type="text"
              readonly
              required
              placeholder="请选择"
              id="picker-priceUnit"
              style="max-width: 4rem;" />
          </div>
        </f7-list-input>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">*</div>
          <div slot="label">付款方式</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-payMethod"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-item link="" @click="assistMaterialsPopupOpened = true">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="inner" class="item-title item-label">辅料</div>
          <div class="item-after popup-smart-select">{{ assistMaterialsDisplay }}</div>
          <f7-popup
            :opened="assistMaterialsPopupOpened"
            @popup:closed="assistMaterialsPopupOpened = false">
            <popup-select
              title="辅料"
              :data="assistMaterialsList"
              :result.sync="project.assistMaterials">
            </popup-select>
          </f7-popup>
        </f7-list-item>
        <f7-list-input :input="false">
          <div slot="media" class="input-required">&nbsp;</div>
          <div slot="label">质量标准</div>
          <input
            slot="input"
            type="text"
            placeholder="请选择"
            id="picker-qualityStandard"
            readonly
            required
            validate/>
        </f7-list-input>
        <f7-list-input
          label="任务说明"
          type="textarea"
          :value="project.projectRemark"
          @input="project.projectRemark = $event.target.value"
          placeholder="请填写"
          validate
          maxlength=500
          error-message='长度0-500字符'
          resizable>
          <div slot="media" class="input-required">&nbsp;</div>
        </f7-list-input>
      </f7-list>
    </div>
  </f7-page>
</template>
<script>
import lodash from 'lodash';
import { createPicker, createCalendar, createToast } from '@/util/compUtils';
import { dateFormat } from '@/util/dateUtils';
import { getDict } from '@/api/common';
import { getSplitView, splitProject, updateSplitProject, splitProjectInfo } from '@/api/project/project';
import { getComanyList } from '@/api/team/worker';
import { SplitProject } from '@/model/reqObject';
import Scope from '@/components/Scope';
import PopupSelect from '@/components/PopupSelect';
import PopupRadio from '@/components/PopupRadio';
import ParentHeader from '@/components/ParentHeader';
import SplitView from '@/components/SplitView';

export default {
  props: ['projectId'],
  components: {
    Scope,
    PopupSelect,
    PopupRadio,
    ParentHeader,
    SplitView,
  },
  data() {
    return {
      editable: lodash.isEmpty(this.projectId),
      majorContractTypeList: [],
      subpackageTypeList: [],
      dutyScopeList: [],
      projectSizeUnitList: [],
      subpackageModeList: [],
      settlementList: [],
      priceUnitList: [],
      assistMaterialsList: [],
      payMethodList: [],
      qualityStandardList: [],
      parent: {},
      project: new SplitProject(),
      majorContractPopupOpened: false,
      scopePopupOpened: false,
      assistMaterialsPopupOpened: false,
      perms: {},
    };
  },
  mounted() {
    const dictKeys = [
      'majorContractType', 'subpackageType', 'projectSizeUnit', 'subpackageMode',
      'projectSettlement', 'priceUnit', 'assistMaterials', 'payMethod', 'qualityStandard',
    ];
    Promise.all([
      getDict({ typeCodes: dictKeys }).then((result) => {
        this.majorContractTypeList = result.data.majorContractType.codeVoList || [];
        this.subpackageTypeList = result.data.subpackageType.codeVoList || [];
        this.projectSizeUnitList = result.data.projectSizeUnit.codeVoList || [];
        this.subpackageModeList = result.data.subpackageMode.codeVoList || [];
        this.settlementList = result.data.projectSettlement.codeVoList || [];
        this.priceUnitList = result.data.priceUnit.codeVoList || [];
        this.assistMaterialsList = result.data.assistMaterials.codeVoList || [];
        this.payMethodList = result.data.payMethod.codeVoList || [];
        this.qualityStandardList = result.data.qualityStandard.codeVoList || [];
      }),
      getComanyList().then((result) => {
        this.companyList = result.data || [];
      }),
      splitProjectInfo({
        projectId: this.$f7route.query.parentId,
      }).then((result) => {
        this.parent = result.data || {};
      }),
    ]).then(() => this.getInfo());
  },
  computed: {
    backUrl() {
      if (lodash.isEmpty(this.projectId)) {
        return `/project/tree/${this.$f7route.query.rootId}`;
      }
      return `/project/info/${this.projectId}?rootId=${this.$f7route.query.rootId}`;
    },
    majorContractDisplay() {
      return this.majorContractTypeList
        .filter(item => item.code === this.project.majorContractType)
        .map(item => item.name)
        .join(',');
    },
    dictKey() {
      const type = this.parent.companyType;
      if (!lodash.isEmpty(type)) {
        if (type === 'laborCompany'
            || type === 'specialtyCompany'
            || type === 'integrateLaborTeam'
            || type === 'specialtyTeam') {
          return this.parent.projectType;
        } else if (type === 'buildingCompany') {
          return 'majorContractType';
        }
        return '';
      }
      return '';
    },
    scopeDisplayVal() {
      return this.dutyScopeList.join(', ');
    },
    assistMaterialsDisplay() {
      return this.assistMaterialsList
        .filter(item => this.project.assistMaterials.includes(item.code))
        .map(item => item.name)
        .join(', ');
    },
  },
  methods: {
    getInfo() {
      if (!lodash.isEmpty(this.projectId)) {
        getSplitView({ projectId: this.projectId }).then((result) => {
          this.project = result.data || {};
          if (!lodash.isEmpty(this.project.dutyScope)) {
            this.dutyScopeList = this.project.dutyScope.split('||');
          }
          this.init();
          this.perms = result.perms || {};
        });
      } else {
        this.init();
      }
    },
    setErrorMsg(elem) {
      elem.addClass('input-invalid');
      let tmpNode = elem;
      while (this.$$(tmpNode).parent() && this.$$(tmpNode).parent().length !== 0) {
        if (tmpNode.hasClass('item-content')) {
          tmpNode.addClass('item-input-with-error-message');
          tmpNode.addClass('item-input-invalid');
          break;
        } else {
          tmpNode = this.$$(tmpNode).parent();
        }
      }
    },
    add() {
      // this.$f7.input.validateInputs('#splitForm');
      if (this.dictKey === 'majorContractType'
        && lodash.isEmpty(this.project.subpackageType)) {
        this.setErrorMsg(this.$$('#picker-subpackageType'));
      }
      if (lodash.isEmpty(this.project.planStartupTime)) {
        this.setErrorMsg(this.$$('#calendar-startTime'));
      }
      if (lodash.isEmpty(this.project.planCompletedTime)) {
        this.setErrorMsg(this.$$('#calendar-finishTime'));
      }
      if (lodash.isEmpty(this.project.sizeUnit)) {
        this.setErrorMsg(this.$$('#picker-sizeUnit'));
      }
      if (lodash.isEmpty(this.project.subpackageMode)) {
        this.setErrorMsg(this.$$('#picker-subpackageMode'));
      }
      if (lodash.isEmpty(this.project.settlement)) {
        this.setErrorMsg(this.$$('#picker-settlement'));
      }
      if (lodash.isEmpty(this.project.priceUnit)) {
        this.setErrorMsg(this.$$('#picker-priceUnit'));
      }
      if (lodash.isEmpty(this.project.payMethod)) {
        this.setErrorMsg(this.$$('#picker-payMethod'));
      }
      if (!lodash.gte(this.project.planCompletedTime, this.project.planStartupTime)) {
        createToast(this, '竣工日期必须大于等于开工日期');
        return;
      }
      if (!lodash.gte(this.project.planStartupTime, dateFormat(this.parent.startupTime))) {
        createToast(this, '开始日期必须大于等于上级任务的开始日期');
        return;
      }
      if (!lodash.lte(this.project.planCompletedTime, dateFormat(this.parent.completedTime))) {
        createToast(this, '结束日期必须小于等于上级任务的结束日期');
        return;
      }
      let valided = true;
      this.$$('#splitForm').find('input, textarea, select').forEach((inputEl) => {
        valided = valided && !this.$$(inputEl).hasClass('input-invalid');
      });
      if (!valided) {
        return;
      }

      let action = updateSplitProject;
      let params = Object.assign(
        this.project,
        { dutyScope: this.dutyScopeList.join('||') },
        { parentId: this.project.parentId || this.$f7route.query.parentId },
      );
      if (lodash.isEmpty(this.projectId)) {
        action = splitProject;
        params = Object.assign(
          params,
          { projectId: this.project.parentId || this.$f7route.query.parentId },
        );
      }
      if (!lodash.isEmpty(this.$f7route.query.preProjectId)) {
        params = Object.assign(
          params,
          { preProjectId: this.project.preProjectId || this.$f7route.query.preProjectId },
        );
      }
      action(params).then((data) => {
        if (data.code === 0) {
          let opt = '拆分';
          if (!lodash.isEmpty(this.projectId)) {
            opt = '修改';
          }
          createToast(this, `${opt}任务成功`);
          this.$f7router.back(this.backUrl);
        }
      });
    },
    init() {
      createPicker(
        this,
        '#picker-subpackageType',
        this.subpackageTypeList.map(d => d.code),
        this.subpackageTypeList.map(d => d.name),
        'project',
        'subpackageType',
      );
      createCalendar(this, '#calendar-startTime', 'project', 'planStartupTime');
      createCalendar(this, '#calendar-finishTime', 'project', 'planCompletedTime');
      createPicker(
        this,
        '#picker-sizeUnit',
        this.projectSizeUnitList.map(d => d.code),
        this.projectSizeUnitList.map(d => d.name),
        'project',
        'sizeUnit',
      );
      createPicker(
        this,
        '#picker-subpackageMode',
        this.subpackageModeList.map(d => d.code),
        this.subpackageModeList.map(d => d.name),
        'project',
        'subpackageMode',
      );
      createPicker(
        this,
        '#picker-settlement',
        this.settlementList.map(d => d.code),
        this.settlementList.map(d => d.name),
        'project',
        'settlement',
      );
      createPicker(
        this,
        '#picker-priceUnit',
        this.priceUnitList.map(d => d.code),
        this.priceUnitList.map(d => d.name),
        'project',
        'priceUnit',
      );
      createPicker(
        this,
        '#picker-payMethod',
        this.payMethodList.map(d => d.code),
        this.payMethodList.map(d => d.name),
        'project',
        'payMethod',
      );
      createPicker(
        this,
        '#picker-qualityStandard',
        this.qualityStandardList.map(d => d.code),
        this.qualityStandardList.map(d => d.name),
        'project',
        'qualityStandard',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .popup-smart-select {
    max-width: 63%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  }

  input.input-invalid::placeholder {
    color: #ff3b30;
  }

  .input-required {
    padding-left: 0.5rem;
    padding-top: 0.4rem;
    color: #FF0000;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/pages/project/split.vue